import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useNavigate, useParams } from "react-router-dom";

import {
  getAllSubscription,
  payForSubscription,
} from "../../../../redux/action/subscription";
import { getWalletAction } from "../../../../redux/action/wallet";
import { capitalizeEveryFirstLetter } from "../../../../helpers/helpers";
import SubscriptionDetailSkelton from "../../../loader/SubscriptionDetailSkelton";
import { ClipLoader } from "react-spinners";

function SubscriptionDetails() {
  const navigate = useNavigate();
  const { id } = useParams();
  const isDastop = useMediaQuery({ query: "(max-width: 1630px)" });
  const isLaptop = useMediaQuery({ query: "(max-width: 1330px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 950px)" });
  const isSmallTablet = useMediaQuery({ query: "(max-width: 700px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 550px)" });
  const dispatch = useDispatch();
  const { subscriptionData, loadings, loading } = useSelector(
    (pre) => pre?.allSubscriptionData
  );
  const [subscriptionValueStore, setSubscriptionValueStore] = useState([]);
  const { wallet } = useSelector((state) => state.wallet);

  const getPaidMemebership = () => {
    dispatch(payForSubscription(id, navigate));
  };

  useEffect(() => {
    dispatch(getAllSubscription());
    dispatch(getWalletAction());
  }, [dispatch]);

  useEffect(() => {
    if (subscriptionData) {
      const filteredData = subscriptionData.filter((item) => item._id === id);
      setSubscriptionValueStore(filteredData[0]);
    }
  }, [subscriptionData, id]);

  if (loadings) {
    return <SubscriptionDetailSkelton />;
  }

  return (
    <>
      <div className="valign-wrapper mt-1">
        <span className="valign-wrapper gap-1">
          <span
            className="material-icons-outlined pointer"
            onClick={() => navigate("/subscription")}
          >
            arrow_back
          </span>
          <h4>Subscription</h4>
        </span>
      </div>
      <div className={`flex column gap-1 ${isDastop ? "" : "container"}`}>
        <div className="flex justify-center ">
          <b className={`valign-wrapper font-16px`}>
            <span className="material-icons-outlined cercle-purple-text mr-1">
              info
            </span>
            You will be billed ₹ {Math.floor(subscriptionValueStore?.price)}{" "}
            monthly for participation in the cerclex auction.
          </b>
        </div>
        <div
          className={`cover ${isMobile ? "p-1" : isSmallTablet ? "p-2" : "grid-2"
            } white`}
        >
          <span className={`${isTablet ? "p-1" : "p-2"}`}>
            <b className="cercle-purple-text">Your Wallet Balance</b>
            <div className="valign-wrapper space-between ml-3">
              <b className="cover font-25px" style={{ padding: "5px 15px" }}>
                ₹ {wallet?.availableBalance || "000"}
              </b>
              <button
                className="button-style white-text cercle-purple pointer"
                style={{ padding: "10px 15px" }}
                onClick={() => navigate("/wallet")}
              >
                Add Money
              </button>
            </div>
          </span>
          <div
            className="valign-wrapper pin-top"
            style={{ width: !isLaptop && "80%" }}
          >
            {!isSmallTablet && (
              <p
                style={{
                  height: "100%",
                  width: "2px",
                  border: "1px solid #eaeaf1",
                }}
              ></p>
            )}
            <p
              className={`ml-3 fontstyle font-16px bold ${isTablet ? "p-1" : "p-2"
                }`}
            >
              Exclusively utilize the Cerclex wallet for all transactions to
              benefit from secure transactions, seamless payment processing, and
              access to exclusive discounts and offers.
            </p>
          </div>
        </div>
        <div className={`cover white p-2`}>
          <span
            className="material-icons-outlined border-1px circle cercle-purple-text"
            style={{ padding: "8px" }}
          >
            check_box
          </span>
          <b className="font-weight-600 font-20px ml-2">
            You have chosen this plan.
          </b>
          <div
            className={`flex mt-1 ${isLaptop ? "justify-center gap-2" : "space-between"
              } flex-wrap`}
          >
            <div
              className="p-1 border-1px border-radius-12  z-depth-2 pin-top"
              style={{ zIndex: "1", width: "400px", height: "140px" }}
            >
              <p
                className=" font-18px lenar-gradiant white-text mb-1"
                style={{
                  padding: "5px 25px",
                  borderRadius: "8px",
                  width: "250px",
                }}
              >
                {capitalizeEveryFirstLetter(subscriptionValueStore?.name)}
              </p>
              <span className="font-30px cercle-purple-text bold">
                ₹ {Math.floor(subscriptionValueStore?.price)}
              </span>
              <span>/monthly</span>
              <div
                className="ribbon white-text"
                style={{
                  backgroundColor:
                    subscriptionValueStore?.name === "Basic"
                      ? "#6f2da8"
                      : "green",
                }}
              >
                {subscriptionValueStore?.name === "Basic"
                  ? "BEST"
                  : subscriptionValueStore?.name === "Standard"
                    ? "POPULAR"
                    : "PREMIUM"}
              </div>
            </div>
            <div
              style={{
                flex: !isTablet && 0.9,
                width: isTablet ? "100%" : "312px",
              }}
            >
              <p className="font-20px cercle-purple-text mb-1 font-weight-600">
                Features
              </p>
              {subscriptionValueStore?.features?.map((item, index) => (
                <p
                  key={item}
                  className="flex gap-1"
                  style={{ minWidth: "500px" }}
                >
                  <span className="material-icons-outlined cercle-purple-text">
                    check
                  </span>
                  {item}
                </p>
              ))}
            </div>
          </div>
          <div className={`flex justify-center mt-3`}>
            {/* <Link to={"/subscription/successful"}> */}
            <button
              className={`button-style white-text cercle-purple pointer `}
              style={{
                padding: isTablet ? "10px" : "16px",
                width: isTablet ? "200px" : "250px",
              }}
              onClick={getPaidMemebership}
            >
              {loading ? (
                <ClipLoader color="#fff" size={20} />
              ) : (
                " Confirm & Send Payment"
              )}
            </button>
            {/* </Link> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default SubscriptionDetails;
